module.exports = __webpack_public_path__ + "img/logo.838d716d.png";